import React, { useState, useEffect, useRef, useCallback, forwardRef, useImperativeHandle } from 'react';
import ReactDOM from 'react-dom';
import { useNavigate } from 'react-router-dom';
import back_n from "../Tutorials/Image/back_n.gif";
import back_o from "../Tutorials/Image/back_o.gif";
import back_d from "../Tutorials/Image/back_d.gif";
import principle_n from "../Tutorials/Image/principle_n.gif";
import tutorials_n from "../Tutorials/Image/tutorials_n.gif";
import clue_n from "../Tutorials/Image/clue_n.gif";
import solution_n from "../Tutorials/Image/solution_n.gif";
import solution_o from "../Tutorials/Image/solution_o.gif";
import solution_d from "../Tutorials/Image/solution_d.gif";
import next_n from "../Tutorials/Image/next_n.gif";
import next_o from "../Tutorials/Image/next_o.gif";
import next_d from "../Tutorials/Image/next_d.gif";
import ok_n from "../Tutorials/Image/ok_n.gif";
import ok_o from "../Tutorials/Image/ok_o.gif";
import ok_d from "../Tutorials/Image/ok_d.gif";
import x_close_btn_n from "../Tutorials/Image/x_close_btn_n.png";
import x_close_btn_o from "../Tutorials/Image/x_close_btn_o.png";
import next_step_btn_n from "../Tutorials/Image/next_step_btn_n.png";
import next_step_btn_o from "../Tutorials/Image/next_step_btn_o.png";
import got_it_btn_n from "../Tutorials/Image/got_it_btn_n.png";
import got_it_btn_o from "../Tutorials/Image/got_it_btn_o.png";
import done_o from "../Tutorials/Image/done_o.gif";
import done_n from "../Tutorials/Image/done_n.gif";
import './Style/Question.css';
import Loading from "../../Common/Loading";
import { buildNextQuestionData, buildOptionOrder, buildShuffledQuestionsOrder, saveQuestionPerformance, QuestionPerformancePayload } from '../../services/questionApi';

export interface AnswerRef {
  getAnswer: () => {
    marks: number;
    noOfOptions: number;
    enteredCorrectAnswer: string;
    enteredWrongAnswer: string;
    enteredBlankAnswer: string;
    optOrder?: string;
    scoringMethod?: number | null;
  } | null;
}

interface DQnsProps {
  lessonMeta?: any;
  questionHtml: string;
  currentPage: number;
  totalPages: number;
  goToNextPage?: (e: React.MouseEvent) => void;
  showAlert: (message: string) => void;
  correctAudio: string[];
  incorrectAudio: string[];
  assetsBaseUrl?: string;
  sessionId: number | null;
  isCompleting?: boolean;
  updateSessionPoints?: (pointsEarned: number) => void;
  hwid?: number | null;
  subject?: string;
  previewMode?: string | null; // same prop Question.tsx already passes to BQns/OQns
}

const DQns: React.ForwardRefRenderFunction<AnswerRef, DQnsProps> = (props, ref) => {
  const { lessonMeta, questionHtml, currentPage, totalPages, goToNextPage, showAlert, correctAudio, incorrectAudio, assetsBaseUrl, sessionId, isCompleting, updateSessionPoints, hwid, subject, previewMode } = props;
  const navigate = useNavigate();
  const [backSrc, setBackSrc] = useState(back_n);
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const folderParam = params.get('folder') || 'RECOG1_E';
  const lessonName = params.get('name') || 'Recognise 1';
  const diccode = params.get('diccode');
  const calledFrom = params.get('calledFrom');

  // Computed once in React, mirrors BQns exactly. This replaces the old
  // runtime `window.parent.location.search` lookup that lived inside the
  // injected iframe script and was silently failing / defaulting to "show
  // whatever the raw HTML had pre-selected" whenever it didn't fire.
  const isViewLesson = params.get("ViewLesson") === "Y";
  const isAnswerMode = previewMode === "ANSWERS" || previewMode === "SOLUTION";
  const isSolutionMode = previewMode === "SOLUTION";
  const showCorrectAnswer = isViewLesson && (isAnswerMode || isSolutionMode);

  const [nextSrc, setNextSrc] = useState(next_n);
  const [okSrc, setOkSrc] = useState(ok_n);
  const [solutionSrc, setSolutionSrc] = useState(solution_n);
  const [CloseBtnSrc, setCloseBtnSrc] = useState(x_close_btn_n);
  const [NextStepBtnSrc, setNextStepBtnSrc] = useState(next_step_btn_n);
  const [GotItBtnSrc, setGotItBtnSrc] = useState(got_it_btn_n);
  const [okClicked, setOkClicked] = useState(false);
  const [currentQnMeta, setCurrentQnMeta] = useState<LessonQnMeta | null>(null);
  const [showClueModal, setShowClueModal] = useState(false);
  const [clueContent,
    setClueContent
  ] = useState('');
  const [isClueLoading, setIsClueLoading] = useState(false);
  const [noOfClues, setNoOfClues] = useState(0);
  const [currentClueNo, setCurrentClueNo] = useState(0);
  const [clueSeen, setClueSeen] = useState(false);
  const clueIframeRef = useRef<HTMLIFrameElement>(null);
  const prcIframeRef = useRef<HTMLIFrameElement>(null);
  const [isPrcLoading, setIsPrcLoading] = useState(false);
  const [showPrcModal, setShowPrcModal] = useState(false);
  const [prcContent,
    setPrcContent
  ] = useState("");
  const [prcSeen, setPrcSeen] = useState(false);
  const [principleList, setPrincipleList] = useState<string[]>([]);
  const [currentPrcIndex, setCurrentPrcIndex] = useState(0);
  const [showSolnModal, setShowSolnModal] = useState(false);
  const [isSolnLoading, setIsSolnLoading] = useState(false);
  const [solnContent,
    setSolnContent
  ] = useState("");
  const [solutionSeen, setSolutionSeen] = useState<string | number>('N');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [currentSolnNo, setCurrentSolnNo] = useState(0);
  const [revealedSolnSteps, setRevealedSolnSteps] = useState<number[]>([]);
  useEffect(() => {
    setCurrentSolnNo(0);
    setRevealedSolnSteps([]);
  }, [currentQnMeta?.QnNo]);
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
  const solnIframeRef = useRef<HTMLIFrameElement>(null);
  const [noOfSteps, setNoOfSteps] = useState(0);
  const [doneSrc, setDoneSrc] = useState(done_n);
  const [answers, setAnswers] = useState<Record<string, string>>({});
  const CORRECT_URL = "https://www.elearnoncloud.com/Storage/assets/Image/Questions/EL_O/AnsCorrect.GIF";
  const [startTime, setStartTime] = useState<Date | null>(null);
  const isInAssessment = window.location.href.includes('Assessment');
  const [explanation, setExplanation] = useState("");

  type LessonQnMeta = {
    QnNo: string;
    QnType: string;
    NoOfClues: number;
    NoOfPrc: number;
    NoOfSol: number;
    LastQnInd: number;
    VarValues?: string;
    PrincipleNos?: string;
  };

  const handleNextStepBtnMouseOver = () => setNextStepBtnSrc(next_step_btn_o);
  const handleNextStepBtnMouseOut = () => setNextStepBtnSrc(next_step_btn_n);
  const handleGotItBtnMouseOver = () => setGotItBtnSrc(got_it_btn_o);
  const handleGotItBtnMouseOut = () => setGotItBtnSrc(got_it_btn_n);
  const handleBackMouseOver = () => setBackSrc(back_o);
  const handleBackMouseOut = () => setBackSrc(back_n);
  const handleBackMouseDown = () => setBackSrc(back_d);
  const handleBackMouseUp = () => setBackSrc(back_o);
  const handleNextMouseOver = () => setNextSrc(next_o);
  const handleNextMouseOut = () => setNextSrc(next_n);
  const handleNextMouseDown = () => setNextSrc(next_d);
  const handleNextMouseUp = () => setNextSrc(next_o);
  const handleOkMouseOver = () => setOkSrc(ok_o);
  const handleOkMouseOut = () => setOkSrc(ok_n);
  const handleOkMouseDown = () => setOkSrc(ok_d);
  const handleOkMouseUp = () => setOkSrc(ok_o);
  const handleSolutionMouseOver = () => setSolutionSrc(solution_o);
  const handleSolutionMouseOut = () => setSolutionSrc(solution_n);
  const handleSolutionMouseDown = () => setSolutionSrc(solution_d);
  const handleCloseBtnMouseOver = () => setCloseBtnSrc(x_close_btn_o);
  const handleCloseBtnMouseOut = () => setCloseBtnSrc(x_close_btn_n);

function injectSelectBridge(
  html: string,
  showCorrectAnswer: boolean,
  isAnswerMode: boolean,
  isSolutionMode: boolean
): string {

  // Remove any existing CMS scripts
  const cleaned = html.replace(/<script[\s\S]*?<\/script>/gi, "");

  const bridge = `
  <style>
    body { margin: 0; padding: 0; }
    p { margin: 0; padding: 0; }

    body, table, td, p, font {
      color: black !important;
    }

    select[id^="dropdown_"],
    select[id="KSD_SELECT"] {
      font-size: 18px;
      background-color: #ffffcc;
      border: 1px solid #ccc;
      padding: 5px;
      color: black;
    }

    select[id^="dropdown_"] option[value=""],
    select[id="KSD_SELECT"] option.default-option {
      color: #888;
      font-style: italic;
    }
  </style>

  <script>
    document.addEventListener('DOMContentLoaded', function() {

      try {

        const showCorrectAnswer = ${JSON.stringify(showCorrectAnswer)};
        const isAnswerMode = ${JSON.stringify(isAnswerMode)};
        const isSolutionMode = ${JSON.stringify(isSolutionMode)};


        let allSelects = Array.from(
          document.querySelectorAll("select")
        ).filter(select =>
          select.options.length > 0 &&
          select.style.display !== "none"
        );

        if (allSelects.length === 0) {
          allSelects = Array.from(document.querySelectorAll("select"));
        }

        allSelects.forEach((select, index) => {

          let correctAnswer = '';

          for (let i = 0; i < select.options.length; i++) {
            if (
              select.options[i].selected ||
              select.options[i].hasAttribute('selected')
            ) {
              correctAnswer = select.options[i].text.trim();
              break;
            }
          }

          if (
            select.id === 'KSD_SELECT' ||
            !select.id.startsWith('dropdown_')
          ) {
            select.id = 'dropdown_' + index;
          }

          if (!showCorrectAnswer) {

            // Student mode

            for (let i = 0; i < select.options.length; i++) {
              select.options[i].removeAttribute('selected');
              select.options[i].selected = false;
            }

            const defaultOption = document.createElement('option');
            defaultOption.value = '';
            defaultOption.textContent = '-- Select --';
            defaultOption.className = 'default-option';
            defaultOption.style.color = '#888';
            defaultOption.style.fontStyle = 'italic';

            select.insertBefore(defaultOption, select.firstChild);

            select.selectedIndex = 0;
            defaultOption.selected = true;

          } else {

            // View Lesson / Preview

            select.disabled =
              isAnswerMode ||
              isSolutionMode;

            for (let i = 0; i < select.options.length; i++) {
              if (
                select.options[i].text.trim() === correctAnswer
              ) {
                select.selectedIndex = i;
                break;
              }
            }
          }

          select.setAttribute(
            'data-correct-answer',
            correctAnswer
          );

          if (!showCorrectAnswer) {

            select.addEventListener(
              'change',
              function(event) {

                const target = event.target;
                const selectedText =
                  target.options[target.selectedIndex]
                    .text
                    .trim();

                if (
                  target.value === '' ||
                  selectedText === '-- Select --'
                ) {
                  target.style.color = '#888';
                  target.style.fontStyle = 'italic';
                } else {
                  target.style.color = 'black';
                  target.style.fontStyle = 'normal';
                }

                if (
                  target.value !== '' &&
                  selectedText !== '-- Select --'
                ) {

                  parent.postMessage(
                    {
                      type: 'el-select-answer',
                      selectId: target.id,
                      selectedValue: selectedText
                    },
                    '*'
                  );

                } else {

                  parent.postMessage(
                    {
                      type: 'el-select-answer',
                      selectId: target.id,
                      selectedValue: ''
                    },
                    '*'
                  );

                }
              }
            );
          }

        });

        const correctAnswers = {};

        allSelects.forEach((select, index) => {

          const selectId =
            select.id || ('dropdown_' + index);

          const correctAnswer =
            select.getAttribute('data-correct-answer');

          if (correctAnswer) {
            correctAnswers[selectId] =
              correctAnswer;
          }
        });

        let correctAnswersInput =
          document.getElementById(
            'correct-answers'
          );

        if (!correctAnswersInput) {

          correctAnswersInput =
            document.createElement('input');

          correctAnswersInput.type = 'hidden';
          correctAnswersInput.id = 'correct-answers';

          document.body.appendChild(
            correctAnswersInput
          );
        }

        correctAnswersInput.value =
          JSON.stringify(correctAnswers);

      } catch (e) {

        console.error(
          "Bridge Error:",
          e
        );

      }

    });
  </script>
  `;

  return cleaned.includes('</body>')
    ? cleaned.replace('</body>', bridge + '</body>')
    : cleaned + bridge;
}

  useImperativeHandle(ref, () => ({
    getAnswer: () => {
      const iframeDoc = iframeRef.current?.contentDocument;
      if (!iframeDoc) return null;

      const correctAnswersEl = iframeDoc.querySelector("#correct-answers") as HTMLInputElement;
      if (!correctAnswersEl) {
        showAlert("Could not verify the answer.");
        return null;
      }

      let correctAnswersMap: Record<string, string> = {};
      try {
        correctAnswersMap = JSON.parse(correctAnswersEl.value);
      } catch (error) {
        showAlert("Could not parse the answer key.");
        return null;
      }

      const validSelectIds = Object.keys(correctAnswersMap);
      const answeredCount = validSelectIds.filter(id => answers[id] && answers[id].trim() !== '').length;

      if (answeredCount < validSelectIds.length) {
        showAlert("Please answer the question");
        return null;
      }

      let correctCount = 0;
      const enteredCorrect: string[] = [];
      const enteredWrong: string[] = [];

      validSelectIds.forEach(selectId => {
        const userAnswer = answers[selectId];
        const correctAnswer = correctAnswersMap[selectId];
        if (userAnswer === correctAnswer) {
          correctCount++;
          enteredCorrect.push(userAnswer);
        } else {
          enteredWrong.push(userAnswer);
        }
      });

      const allCorrect = correctCount === validSelectIds.length;
      const marks = allCorrect ? 1 : 0;

      return {
        marks,
        noOfOptions: validSelectIds.length,
        enteredCorrectAnswer: enteredCorrect.join('|'),
        enteredWrongAnswer: enteredWrong.join('|'),
        enteredBlankAnswer: "",
        optOrder: buildOptionOrder(iframeRef.current, 'D'),
        scoringMethod: null
      };
    }
  }));

  useEffect(() => {
    if (!iframeRef.current?.contentDocument?.body) {
      return;
    }

    const iframeDoc = iframeRef.current.contentDocument;

    const oldHr = iframeDoc.getElementById("explanation-hr");
    const oldTitle = iframeDoc.getElementById("explanation-title");
    const oldMessage = iframeDoc.getElementById("explanation-message");
    if (oldHr) oldHr.remove();
    if (oldTitle) oldTitle.remove();
    if (oldMessage) oldMessage.remove();

    if (explanation) {
      const mainTable = iframeDoc.querySelector('body > table');

      if (mainTable) {
        const hr = iframeDoc.createElement('hr');
        hr.id = "explanation-hr";
        hr.style.cssText = "height:1px; background-color:#cfcfcf; border:none; margin: 30px;";

        const titleP = iframeDoc.createElement('p');
        titleP.id = "explanation-title";
        titleP.style.cssText = "font-size: 24px; color: #797979; font-family: Arial, Helvetica, sans-serif; line-height: 30px; padding-left: 30px; margin-top: 0px; margin-bottom: 20px;";
        titleP.innerText = "Explanation";

        const messageP = iframeDoc.createElement('p');
        messageP.id = "explanation-message";
        messageP.style.cssText = "font-size: 24px; color: #000000; font-family: Arial, Helvetica, sans-serif; line-height: 30px; padding-left: 30px; margin-top: 0px; margin-bottom: 50px;";
        messageP.innerText = explanation;

        mainTable.after(hr, titleP, messageP);

      } else {
        iframeDoc.body.appendChild(document.createTextNode("Explanation: " + explanation));
      }
    }
  }, [explanation, questionHtml]);

  const playRandomSound = useCallback(async (soundFiles: string[], folder: 'Correct' | 'Incorrect') => {
    const baseUrl = assetsBaseUrl || "https://www.elearnoncloud.com/Storage/assets/";
    if (!soundFiles || soundFiles.length === 0) return;
    const fileName = soundFiles[Math.floor(Math.random() * soundFiles.length)];
    const audioUrl = `${baseUrl}Audio/Question/${folder}/${fileName}`;
    const audio = new Audio(audioUrl);
    try { await audio.play(); } catch (error) { console.error(`Error playing audio from ${audioUrl}:`, error); }
  }, [assetsBaseUrl]);

  const handleSolnClick = useCallback(async (autoExpand = false) => {
    if (!currentQnMeta || !lessonMeta) return;

    setShowSolnModal(true);
    setIsSolnLoading(true);
    setSolnContent("");
    setNoOfSteps(0);

    const searchParams = new URLSearchParams(window.location.search);
    const folderParam = searchParams.get('folder');
    const countryParam = searchParams.get('country') || 'Australia';

    if (!folderParam) {
      showAlert("Could not determine the lesson folder.");
      setIsSolnLoading(false);
      setShowSolnModal(false);
      return;
    }

    const accessToken = localStorage.getItem('access_token');
    const headers: HeadersInit = { 'Content-Type': 'application/json' };
    if (accessToken) {
      headers['Authorization'] = `Bearer ${accessToken}`;
    } else {
      console.warn("Access token not found in localStorage.");
    }

    const apiUrl = process.env.REACT_APP_DOCUMENT_LINK;

    try {
      const response = await fetch(`${apiUrl}solution/`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          folder: folderParam,
          questionNo: currentQnMeta.QnNo,
          country: countryParam,
          autoExpand: autoExpand,
        }),
      });

      if (!response.ok) {
        if (response.status === 401 || response.status === 403) {
          showAlert("Authentication failed. Please log in again.");
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setSolnContent(data.solutionHtml || "");
      if (solutionSeen === 'N') {
        setSolutionSeen(1);
      }

    } catch (error) {
      console.error("Error fetching solution:", error);
      if (!(error instanceof Error && (error.message.includes("status: 401") || error.message.includes("status: 403")))) {
        showAlert("Failed to load the solution. Please try again.");
      }
      setShowSolnModal(false);
    } finally {
      setIsSolnLoading(false);
    }
  }, [currentQnMeta, lessonMeta, showAlert, solutionSeen]);

  const handleDbUpdate = useCallback((payload: QuestionPerformancePayload) => {
    return saveQuestionPerformance(payload)
      .then((data) => {
        if (isCompleting && updateSessionPoints) {
          updateSessionPoints(data.pointsEarned || 0);
        }
        return data;
      })
      .catch((error) => {
        console.error("Save Performance Error:", error);
        throw error;
      });
  }, [isCompleting, updateSessionPoints]);

  const handleOkClick = useCallback(async (e: React.MouseEvent<any>) => {
    e.preventDefault();
    if (okClicked || isSubmitting) return;
    const isCompleting = currentPage === totalPages;

    const iframeDoc = iframeRef.current?.contentDocument;
    if (!iframeDoc) return;

    const correctAnswersEl = iframeDoc.querySelector("#correct-answers") as HTMLInputElement;
    if (!correctAnswersEl) {
      showAlert("Could not verify the answer.");
      return;
    }

    let correctAnswersMap: Record<string, string> = {};
    try {
      correctAnswersMap = JSON.parse(correctAnswersEl.value);
    } catch (error) {
      showAlert("Could not parse the answer key.");
      return;
    }

    const validSelectIds = Object.keys(correctAnswersMap);
    const answeredCount = validSelectIds.filter(id => answers[id] && answers[id].trim() !== '' && answers[id] !== '-- Select --').length;

    if (answeredCount < validSelectIds.length) {
      showAlert("Please answer the question");
      return;
    }

    const enteredCorrect: string[] = [];
    const enteredWrong: string[] = [];
    let correctCount = 0;
    const totalQuestions = validSelectIds.length;

    validSelectIds.forEach(selectId => {
      const userAnswer = answers[selectId];
      const correctAnswer = correctAnswersMap[selectId];
      if (userAnswer === correctAnswer) {
        correctCount++;
        enteredCorrect.push(userAnswer);
      } else {
        enteredWrong.push(userAnswer);
      }
    });

    const marks = totalQuestions > 0 ? correctCount / totalQuestions : 0;
    const questionAnswerTime = startTime ? Math.floor((new Date().getTime() - startTime.getTime()) / 1000) : 0;
    const schoolCode = sessionStorage.getItem('SchoolCode') || '';
    const familyCode = sessionStorage.getItem('FamilyCode') || '';
    const login = sessionStorage.getItem('Login') || '';
    const chapterCode = sessionStorage.getItem('ChapterCode') || '';
    const unitCode = sessionStorage.getItem('UnitCode') || '';

    const payload: QuestionPerformancePayload = {
      schoolCode,
      familyCode,
      login,
      dicCode: sessionStorage.getItem('SelectedDICFile') || '',
      lsnTestCode: sessionStorage.getItem('LsnTestCode') || '',
      sessionId: sessionId || 1,
      qnNo: currentQnMeta?.QnNo || '',
      subNo: 0,
      qnType: currentQnMeta?.QnType || '',
      marks: marks,
      noOfOptions: totalQuestions,
      optOrder: buildOptionOrder(iframeRef.current, 'D'),
      enteredCorrectAnswer: enteredCorrect.join('|'),
      enteredWrongAnswer: enteredWrong.join('|'),
      enteredBlankAnswer: "",
      solutionSeen: (typeof solutionSeen === 'number' && solutionSeen > 0) || solutionSeen === 'Y' ? 'Y' : 'N',
      clueSeen: clueSeen,
      principleSeen: prcSeen,
      questionLoadTime: 0,
      questionAnswerTime: questionAnswerTime,
      lastQnInd: currentQnMeta?.LastQnInd || currentPage,
      nextQnData: buildNextQuestionData(lessonMeta?.qns, currentPage),
      dbgShuffledQnsOrder: buildShuffledQuestionsOrder(lessonMeta?.qns),
      allQuestionsCompleted: isCompleting ? 'True' : 'False',
      chapterCode: chapterCode,
      unitCode: unitCode,
      hwid: hwid,
      subject: subject
    };

    const isLastQuestion = currentPage === totalPages;
    if (isLastQuestion) {
      setIsSubmitting(true);
      try {
        if (!isViewLesson) {
          await handleDbUpdate(payload);
        }
      } catch (e) {
        console.error("Final submit failed", e);
        showAlert("Error saving progress. Please try again.");
        setIsSubmitting(false);
        return;
      }
      setIsSubmitting(false);
    } else {
      if (!isViewLesson) {
        handleDbUpdate(payload).catch(e =>
          console.error("Background save failed", e)
        );
      }
    }

    validSelectIds.forEach(selectId => {
      const selectEl = iframeDoc.getElementById(selectId) as HTMLSelectElement;
      const userAnswer = answers[selectId];
      const correctAnswer = correctAnswersMap[selectId];

      if (selectEl) {
        const isCorrect = userAnswer === correctAnswer;
        selectEl.style.display = 'none';
        const resultSpan = iframeDoc.createElement('span');
        resultSpan.style.fontSize = '18px';
        resultSpan.style.fontFamily = 'Arial';

        if (isCorrect) {
          resultSpan.innerHTML = `
        <span style="color:green;font-weight:bold;">
            ${correctAnswer}
        </span>
        <img src="${CORRECT_URL}"
             style="vertical-align:middle;height:20px;" />
    `;
        } else {

          const WRONG_URL =
            "https://www.elearnoncloud.com/Storage/assets/Image/Questions/EL_O/AnsWrong.GIF";

          resultSpan.innerHTML = `
        <span style="color:red;text-decoration:line-through;">
            ${userAnswer}
        </span>
        &nbsp;
        <span style="color:green;font-weight:bold;">
            ${correctAnswer}
        </span>
        <img src="${WRONG_URL}"
             style="vertical-align:middle;height:20px;" />
    `;
        }

        resultSpan.style.display = "inline-block";
        resultSpan.style.marginLeft = "6px";

        selectEl.parentNode?.insertBefore(resultSpan, selectEl.nextSibling);
      }
    });

    const scoreMessage = `You scored ${correctCount} ${correctCount !== 1 ? "marks" : "mark"} out of ${totalQuestions}`;

    if (!iframeDoc.getElementById("el-explanation-container")) {
      const container = iframeDoc.createElement("div");
      container.id = "el-explanation-container";
      container.innerHTML = `
            <hr style='height:1px; background-color:#cfcfcf; border:none; margin-top:50px; margin-bottom:30px; margin-left:30px; margin-right:30px;'>
            <p style='font-size:24px; color:#797979; font-family:Arial,Helvetica,sans-serif; line-height:30px; padding-left:30px; padding-right:30px; margin-top:0px; margin-bottom:20px'>Explanation</p>
            <p style='font-size:24px; color:#000000; font-family:Arial,Helvetica,sans-serif; line-height:30px; padding-left:30px; padding-right:30px; margin-top:0px; margin-bottom:50px'>
                ${scoreMessage}
            </p>
        `;
      iframeDoc.body.appendChild(container);
      setTimeout(() => {
        iframeDoc.documentElement.scrollTop = iframeDoc.documentElement.scrollHeight;
      }, 100);
    }

    const allCorrect = correctCount === totalQuestions;
    if (allCorrect) {
      playRandomSound(correctAudio, 'Correct');
      setExplanation("");
    } else {
      playRandomSound(incorrectAudio, 'Incorrect');

      setExplanation("Incorrect selections are shown with a strikethrough.");

      if (currentQnMeta?.NoOfSol && currentQnMeta.NoOfSol > 0) {
        handleSolnClick(true);
      }
    }

    setOkClicked(true);
  }, [answers, okClicked, showAlert, handleSolnClick, CORRECT_URL, correctAudio, incorrectAudio, playRandomSound, startTime, currentQnMeta, clueSeen, showPrcModal, solutionSeen, currentPage, totalPages, sessionId, isCompleting, updateSessionPoints, handleDbUpdate, hwid, subject, isViewLesson]);

  const fetchPrincipleContent = async (principleId: string, folderParam: string, countryParam: string) => {
    const accessToken = localStorage.getItem('access_token');
    const headers: HeadersInit = { 'Content-Type': 'application/json' };
    if (accessToken) headers['Authorization'] = `Bearer ${accessToken}`;

    const apiUrl = process.env.REACT_APP_DOCUMENT_LINK;

    const response = await fetch(`${apiUrl}principle/`, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        folder: folderParam,
        questionNo: principleId,
        country: countryParam,
      }),
    });

    if (!response.ok) throw new Error("Failed");
    return await response.json();
  };

  const handlePrcClick = useCallback(async () => {
    if (!currentQnMeta || !lessonMeta) return;

    const prcString = currentQnMeta.PrincipleNos || "";
    const prcIds = prcString.replace(/"/g, "").split(',').filter((s: string) => s.trim() !== "");

    if (prcIds.length === 0) {
      if ((currentQnMeta.NoOfPrc || 0) > 0) {
        prcIds.push("1");
      } else {
        showAlert("No principles found for this question.");
        return;
      }
    }

    setShowPrcModal(true);
    setIsPrcLoading(true);
    setPrcContent("");
    setPrincipleList(prcIds);
    setCurrentPrcIndex(0);

    const searchParams = new URLSearchParams(window.location.search);
    const folderParam = searchParams.get('folder');
    const countryParam = params.get('country') || 'Australia';

    if (!folderParam) {
      showAlert("Could not determine the lesson folder.");
      setIsPrcLoading(false);
      setShowPrcModal(false);
      return;
    }

    try {
      const data = await fetchPrincipleContent(prcIds[0], folderParam, countryParam);
      setPrcContent(data.principleHtml || "");
      setPrcSeen(true);
    } catch (error) {
      console.error("Error fetching principle:", error);
      setPrcContent("");
    } finally {
      setIsPrcLoading(false);
    }
  }, [currentQnMeta, lessonMeta, showAlert, params]);

  const handleClueClick = useCallback(async () => {
    if (!currentQnMeta || !lessonMeta) return;

    setShowClueModal(true);
    setIsClueLoading(true);
    setClueContent("");
    setCurrentClueNo(0);
    setNoOfClues(0);

    const searchParams = new URLSearchParams(window.location.search);
    const folderParam = searchParams.get('folder');
    const countryParam = params.get('country') || 'Australia';
    const varValuesParam = currentQnMeta?.VarValues || "";

    if (!folderParam) {
      showAlert("Could not determine the lesson folder.");
      setIsClueLoading(false);
      setShowClueModal(false);
      return;
    }

    const accessToken = localStorage.getItem('access_token');
    const headers: HeadersInit = { 'Content-Type': 'application/json' };
    if (accessToken) {
      headers['Authorization'] = `Bearer ${accessToken}`;
    } else {
      console.warn("Access token not found in localStorage.");
    }

    const apiUrl = process.env.REACT_APP_DOCUMENT_LINK;

    try {
      const response = await fetch(`${apiUrl}clue/`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          folder: folderParam,
          questionNo: currentQnMeta.QnNo,
          country: countryParam,
          varValues: varValuesParam,
        }),
      });

      if (!response.ok) {
        if (response.status === 404) {
          setClueContent("");
        } else {
          if (response.status === 401 || response.status === 403) {
            showAlert("Authentication failed. Please log in again.");
          }
          throw new Error(`HTTP error! status: ${response.status}`);
        }
      } else {
        const data = await response.json();
        setClueContent(data.clueHtml || "");
        setClueSeen(true);
      }

    } catch (error) {
      console.error("Error fetching clue:", error);
      if (!(error instanceof Error && (error.message.includes("status: 401") || error.message.includes("status: 403") || error.message.includes("status: 404")))) {
        showAlert("Failed to load the clue. Please try again.");
      }
      setClueContent("");
    } finally {
      setIsClueLoading(false);
    }
  }, [currentQnMeta, lessonMeta, showAlert, params]);

  useEffect(() => {
    setOkClicked(false);
    setAnswers({});
    setSolutionSeen('N');
    setClueSeen(false);
    setPrcSeen(false);
    setStartTime(new Date());
    setExplanation("");
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === "el-select-answer") {
        setAnswers(prev => ({ ...prev, [event.data.selectId]: event.data.selectedValue }));
      }
    };
    window.addEventListener("message", handleMessage);
    if (iframeRef.current && questionHtml) {
      // Pass the React-computed flags in instead of letting the iframe
      // figure it out itself.
      iframeRef.current.srcdoc = injectSelectBridge(questionHtml, showCorrectAnswer, isAnswerMode, isSolutionMode);
      const html = injectSelectBridge(
        questionHtml,
        showCorrectAnswer,
        isAnswerMode,
        isSolutionMode
      );

    

      iframeRef.current.srcdoc = html;
    }
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [currentPage, questionHtml, showCorrectAnswer, isAnswerMode, isSolutionMode]);

  useEffect(() => {
    if (lessonMeta?.qns) {
      setCurrentQnMeta(lessonMeta.qns[currentPage - 1]);
    }
  }, [currentPage, lessonMeta]);

  const handleBack = () => {
    const calledFrom = params.get("calledFrom");

    // console.log("calledFrom:", calledFrom);
    if (calledFrom) {
      const redirectPath = decodeURIComponent(calledFrom);
      window.location.href = redirectPath;
    }
    else if (window.history.length > 1) {
      window.history.back();
    }
  };

  return (
    <>
      {!isInAssessment && (
        <tr id="trQnButtons">
          <td className="QnPanelT">
            <table id="tabQnNav" className="QnPanel2T" style={{ height: "50px" }}>
              <tbody>
                <tr id="trQnOK" className="trQnOKT">
                  <td id="QnPanelIdT" className="QnPanel">&nbsp;</td>
                  <td id="QnPanelId2T" className="QnPanel">
                    <div
                      onClick={!okClicked ? handleBack : undefined}
                      style={{ display: okClicked ? 'none' : 'block', cursor: 'pointer' }}
                    >
                      <div id="imgbtnBack" className="imgbtnBackT">
                        <img
                          src={backSrc}
                          alt="Back"
                          onMouseOver={handleBackMouseOver}
                          onMouseOut={handleBackMouseOut}
                          onMouseDown={handleBackMouseDown}
                          onMouseUp={handleBackMouseUp}
                          className="imgbtnBack2T"
                        />
                      </div>
                    </div>
                  </td>
                  <td id="QnPanelId3T" className="QnPanel">
                    <input
                      type="image"
                      id="imgPrc"
                      src={principle_n}
                      className="imgPrcT"
                      alt="Principle"
                      style={{ display: !okClicked && currentQnMeta?.NoOfPrc && currentQnMeta.NoOfPrc > 0 ? 'inline-block' : 'none' }}
                      onClick={(e) => { e.preventDefault(); handlePrcClick(); }}
                    />
                  </td>
                  <td id="QnPanelId4T" className="QnPanel">
                    <input
                      type="image"
                      id="imgClue"
                      src={clue_n}
                      className="imgClueT"
                      alt="Clue"
                      style={{ display: !okClicked && Number(currentQnMeta?.NoOfClues || 0) > 0 ? 'inline-block' : 'none' }}
                      onClick={(e) => { e.preventDefault(); handleClueClick(); }}
                    />
                  </td>
                  <td id="QnPanelId5T" className="QnPanel">
                    <input
                      type="image" id="imgSoln" src={solutionSrc} className="imgSolnT" alt="Solution"
                      style={{ display: currentQnMeta?.NoOfSol && currentQnMeta.NoOfSol > 0 ? 'inline-block' : 'none' }}
                      onClick={(e) => { e.preventDefault(); handleSolnClick(false); }}
                      onMouseOver={handleSolutionMouseOver}
                      onMouseOut={handleSolutionMouseOut}
                      onMouseDown={handleSolutionMouseDown}
                    />
                  </td>
                  <td id="QnPanelId5T" className="QnPanel">
                    <a
                      href={`/STUDENT/Tutorials/Tutorial?id=${folderParam}&name=${encodeURIComponent(lessonName ?? '')}&folder=${encodeURIComponent(diccode ?? '')}&calledFrom=${encodeURIComponent(calledFrom ?? '')}&sessionId=${sessionId}&currentPage=${currentPage}`}
                      id="imgbtnTut"
                      className="imgbtnTutT"
                      style={{ display: okClicked ? 'none' : 'inline-block' }}
                    >
                      <img src={tutorials_n} alt="Tutorial" id="imgbtnTut2T" />
                    </a>
                  </td>
                  <td id="QnPanelId6T" className="QnPanel">
                    {isSubmitting ? (
                      <Loading />
                    ) : (
                      okClicked ? (
                        currentPage === totalPages ? (
                          <img
                            src={doneSrc}
                            alt="Done"
                            style={{ verticalAlign: 'middle', cursor: 'pointer' }}
                            onClick={() => {

                              // View Lesson Preview
                              if (isViewLesson) {
                                const calledFrom =
                                  params.get("CalledFrom") ||
                                  params.get("calledFrom");

                                if (calledFrom) {
                                  window.location.href = decodeURIComponent(calledFrom);
                                } else {
                                  window.history.back();
                                }
                                return;
                              }

                              // Student flow (unchanged)
                              const dicCode = sessionStorage.getItem('SelectedDICFile') || '';
                              const lsnTestCode = sessionStorage.getItem('LsnTestCode') || '';
                              const calledFrom = params.get("calledFrom") || "";

                              navigate(
                                `/STUDENT/Tutorials/Result?DicCode=${dicCode}&LsnTestCode=${lsnTestCode}&SessionID=${sessionId}&source=lesson&complete=1` +
                                (calledFrom ? `&calledFrom=${encodeURIComponent(calledFrom)}` : "")
                              );
                            }}
                            onMouseOver={() => setDoneSrc(done_o)}
                            onMouseOut={() => setDoneSrc(done_n)}
                          />
                        ) : (
                          <img
                            src={nextSrc}
                            alt="Next"
                            onClick={goToNextPage}
                            onMouseOver={handleNextMouseOver}
                            onMouseOut={handleNextMouseOut}
                            onMouseDown={handleNextMouseDown}
                            onMouseUp={handleNextMouseUp}
                            style={{ display: 'inline-block', cursor: 'pointer', marginTop: '3px' }}
                          />
                        )
                      ) : (
                        <div
                          onClick={handleOkClick}
                          onMouseOver={handleOkMouseOver}
                          onMouseOut={handleOkMouseOut}
                          onMouseDown={handleOkMouseDown}
                          onMouseUp={handleOkMouseUp}
                          style={{ display: 'inline-block', cursor: 'pointer' }}
                        >
                          <img src={okSrc} alt="OK" style={{ marginTop: '3px' }} />
                        </div>
                      )
                    )}
                  </td>
                  <td id="QnPanelId7" className="QnPanel">&nbsp;</td>
                </tr>
                <tr id="trQnNext" className="trQnNextT">
                  <td id="tdBN1" className="QnPanel">&nbsp;</td>
                  <td id="tdAnsMsg" className="QnPanel">&nbsp;</td>
                  <td id="tdShowCA" className="QnPanel">&nbsp;</td>
                  <td id="tdAnsSoln" className="QnPanel">
                    <img
                      id="imgSolnAfterAnswering"
                      src={solutionSrc}
                      alt="Solution"
                      onMouseOver={handleSolutionMouseOver}
                      onMouseOut={handleSolutionMouseOut}
                      onMouseDown={handleSolutionMouseDown}
                    />
                  </td>
                  <td id="tdQnNext" className="QnPanel">
                    {okClicked ? (
                      <input
                        type="image"
                        id="imgNextQuestion"
                        src={nextSrc}
                        alt="Next"
                        onClick={goToNextPage}
                        onMouseOver={handleNextMouseOver}
                        onMouseOut={handleNextMouseOut}
                        onMouseDown={handleNextMouseDown}
                        onMouseUp={handleNextMouseUp}
                        style={{ display: okClicked ? 'inline-block' : 'none' }}
                      />
                    ) : (
                      <img
                        id="imgOK"
                        src={okSrc}
                        alt="OK"
                        onClick={handleOkClick}
                        onMouseOver={handleOkMouseOver}
                        onMouseOut={handleOkMouseOut}
                        onMouseDown={handleOkMouseDown}
                        onMouseUp={handleOkMouseUp}
                        className="imgOKT"
                        style={{ display: okClicked ? 'none' : 'inline-block' }}
                      />
                    )}
                  </td>
                  <td id="tdBN" className="QnPanel">&nbsp;</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      )}
      <tr id="triFrame">
        <td id="tdFrameQnT" style={{ padding: 0, height: '100%' }}>
          <div id="divFrameQn" style={{ height: 'calc(95vh - 50px)', width: '100%', display: 'flex', flexDirection: 'column' }}>
            {questionHtml ? (
              <iframe
                id="iFrameQn"
                ref={iframeRef}
                frameBorder={0}
                scrolling="yes"
                className="CssiFrm"
                style={{
                  flex: '1 1 0',
                  width: '100%',
                  height: '100%',
                  minHeight: 0,
                  border: 'none',
                  overflow: 'auto'
                }}
                title="Question Page"
              />
            ) : <Loading />}
          </div>
        </td>
      </tr>

      {ReactDOM.createPortal(
        <>
          {showClueModal && (
            <>
              {!showSolnModal && <div id="divReadOnlyScreen" style={{ display: 'block' }} onClick={() => setShowClueModal(false)}></div>}
              <div id="divClue" style={{ display: 'block' }}>
                <table id="tblTitleClue" className="clue" cellSpacing="0" cellPadding="0" width="100%" style={{ height: "50px", fontSize: "15px" }}>
                  <tbody>
                    <tr>
                      <td id="tdClueTitle1" align="left">Clue</td>
                      <td id="tdClueClose" align="right" valign="top">
                        <img
                          id="imgClueClose"
                          src={CloseBtnSrc}
                          alt="Close"
                          onClick={() => setShowClueModal(false)}
                          onMouseOver={handleCloseBtnMouseOver}
                          onMouseOut={handleCloseBtnMouseOut}
                          style={{ cursor: 'pointer', padding: '5px' }}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div id="divFrameClue">
                  {isClueLoading ? <Loading /> : (
                    <iframe
                      id="iFrameClue"
                      ref={clueIframeRef}
                      title="Clue"
                      srcDoc={clueContent}
                      style={{ width: '100%', border: 'none', minHeight: '80px' }}
                      onLoad={() => {
                        const iframe = clueIframeRef.current;
                        if (!iframe || !iframe.contentDocument || !iframe.contentWindow) { return; }
                        try {
                          const divShows = iframe.contentDocument.querySelectorAll("[id^='divShow']");
                          divShows.forEach(div => {
                            (div as HTMLElement).style.padding = "20px";
                          });
                          const cluesInput = iframe.contentDocument.getElementById('NoOfClues') as HTMLInputElement;
                          const totalClues = parseInt(cluesInput?.value || '0', 10);
                          setNoOfClues(totalClues);
                          const clueDivs = iframe.contentDocument.querySelectorAll<HTMLElement>('[id^="divShow"]');
                          clueDivs.forEach((div, index) => {
                            div.style.display = index === 0 ? 'block' : 'none';
                          });
                          const firstClueDiv = iframe.contentDocument.getElementById('divShow1');
                          if (firstClueDiv) {
                            const newHeight = firstClueDiv.scrollHeight;
                            iframe.style.height = `${Math.min(newHeight, 300)}px`;
                          } else if (totalClues === 0) {
                            iframe.style.height = '50px';
                          }
                        } catch (e) { console.error("Error inside clue iframe onLoad:", e); }
                      }}
                    />
                  )}
                </div>
                <table id="tblNavClue" className="clue" cellSpacing="0" cellPadding="0" width="100%" style={{ backgroundColor: '#F2F2F2' }}>
                  <tbody>
                    <tr>
                      <td style={{ width: '33%' }}>&nbsp;</td>
                      <td style={{ width: '34%' }}>&nbsp;</td>
                      <td align="right" style={{ width: '33%', paddingRight: '15px' }}>
                        {!isClueLoading && noOfClues > 1 && currentClueNo < noOfClues - 1 && (
                          <img
                            id="btnClueNext"
                            src={NextStepBtnSrc}
                            alt="Next Clue"
                            onClick={() => {
                              const nextClue = currentClueNo + 1;
                              const iframe = clueIframeRef.current;
                              if (iframe?.contentDocument) {
                                iframe.contentDocument.querySelectorAll<HTMLElement>('[id^="divShow"]').forEach((div, index) => {
                                  div.style.display = index === nextClue ? 'block' : 'none';
                                });
                                setCurrentClueNo(nextClue);
                                const nextClueDiv = iframe.contentDocument.getElementById(`divShow${nextClue + 1}`);
                                if (nextClueDiv) {
                                  const newHeight = nextClueDiv.scrollHeight + 20;
                                  iframe.style.height = `${Math.min(newHeight, 300)}px`;
                                }
                              }
                            }}
                            onMouseOver={handleNextStepBtnMouseOver}
                            onMouseOut={handleNextStepBtnMouseOut}
                            style={{ cursor: 'pointer' }}
                          />
                        )}
                        {!isClueLoading && (noOfClues <= 1 || currentClueNo === noOfClues - 1) && (
                          <img
                            id="btnClueGotIt"
                            src={GotItBtnSrc}
                            alt="Got It"
                            onClick={() => setShowClueModal(false)}
                            onMouseOver={handleGotItBtnMouseOver}
                            onMouseOut={handleGotItBtnMouseOut}
                            style={{ cursor: 'pointer', display: isClueLoading ? 'none' : 'inline-block' }}
                          />
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </>
          )}

          {showPrcModal && (
            <>
              <div id="divReadOnlyScreen" style={{ display: 'block' }} onClick={() => setShowPrcModal(false)}></div>

              <div id="divPCS" style={{ display: 'block' }} className="principle">

                {/* Header */}
                <table id="tblTitlePCS" className="principle" cellSpacing="0" cellPadding="0" width="100%">
                  <tbody>
                    <tr>
                      <td id="tdPCSTitle1" style={{ paddingLeft: '15px', color: 'white', fontWeight: 'bold', fontSize: '24px' }}>
                        Principle {principleList.length > 1 ? ` ${currentPrcIndex + 1} of ${principleList.length}` : ''}
                      </td>
                      <td id="tdPCSClose" align="right" valign="top">
                        <img
                          id="imgPCSClose"
                          src={CloseBtnSrc}
                          alt="Close"
                          onClick={() => { setShowPrcModal(false); setIsPrcLoading(false); }}
                          onMouseOver={handleCloseBtnMouseOver}
                          onMouseOut={handleCloseBtnMouseOut}
                          style={{ cursor: 'pointer', padding: '5px', width: '40px', height: '40px', marginRight: '30px' }}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>

                {/* Body */}
                <div id="divFramePCS">
                  {isPrcLoading ? <Loading /> : (
                    <iframe
                      id="iFramePrc"
                      ref={prcIframeRef}
                      title="Prc"
                      srcDoc={prcContent}
                      style={{ width: '100%', border: 'none', overflow: 'hidden', display: 'block' }} // 2. Set overflow hidden initially
                      onLoad={() => {
                        const iframe = prcIframeRef.current;
                        if (!iframe || !iframe.contentDocument || !iframe.contentWindow) return;

                        setTimeout(() => {
                          if (!iframe.contentDocument || !iframe.contentDocument.body) return;

                          const contentHeight = iframe.contentDocument.body.scrollHeight + 20;

                          const divPCS = document.getElementById('divPCS') as HTMLElement;
                          const titleTable = document.getElementById('tblTitlePCS') as HTMLElement;
                          const navTable = document.getElementById('tblNavPCS') as HTMLElement;
                          if (divPCS && titleTable && navTable) {
                            const maxModalHeight = window.innerHeight * 0.8;
                            const maxIframeHeight = maxModalHeight - titleTable.offsetHeight - navTable.offsetHeight;
                            if (contentHeight > maxIframeHeight) {

                              iframe.style.height = `${maxIframeHeight}px`;
                              iframe.style.overflowY = 'auto';
                            } else {

                              iframe.style.height = `${Math.max(contentHeight, 80)}px`;
                              iframe.style.overflowY = 'hidden';
                            }
                          } else {
                            iframe.style.height = `${Math.max(contentHeight, 80)}px`;
                          }
                        }, 50);
                      }}
                    />
                  )}
                </div>

                {/* Footer / Navigation */}
                <table id="tblNavPCS" className="principle" cellSpacing="0" cellPadding="0" width="100%" style={{ height: '50px' }}>
                  <tbody>
                    <tr style={{ backgroundColor: '#F2F2F2' }}>
                      {/* Previous Button */}
                      <td align="left" style={{ width: '33%', paddingLeft: '15px' }}>
                        {currentPrcIndex > 0 && (
                          <input
                            type='button'
                            value='PREVIOUS'
                            onClick={() => {
                              const prevIndex = currentPrcIndex - 1;
                              setCurrentPrcIndex(prevIndex);
                              const folderParam = new URLSearchParams(window.location.search).get('folder') || '';
                              const countryParam = params.get('country') || 'Australia';
                              fetchPrincipleContent(principleList[prevIndex], folderParam, countryParam).then(data => setPrcContent(data.principleHtml || ""));
                            }}
                            style={{
                              fontWeight: 'bold',
                              color: 'White',
                              fontSize: '12pt',
                              borderStyle: 'none',
                              backgroundColor: 'maroon',
                              cursor: 'pointer',
                              padding: '5px 10px'
                            }}
                          />
                        )}
                      </td>

                      <td style={{ width: '34%' }}>&nbsp;</td>

                      {/* Next / Got It Button */}
                      <td align="right" style={{ width: '33%', paddingRight: '15px' }}>
                        {currentPrcIndex < principleList.length - 1 ? (
                          <img
                            src={NextStepBtnSrc}
                            alt="Next"
                            onClick={() => {
                              const nextIndex = currentPrcIndex + 1;
                              setCurrentPrcIndex(nextIndex);
                              const folderParam = new URLSearchParams(window.location.search).get('folder') || '';
                              const countryParam = params.get('country') || 'Australia';
                              fetchPrincipleContent(principleList[nextIndex], folderParam, countryParam).then(data => setPrcContent(data.principleHtml || ""));
                            }}
                            onMouseOver={handleNextStepBtnMouseOver}
                            onMouseOut={handleNextStepBtnMouseOut}
                            style={{ cursor: 'pointer', width: '100px', height: '40px', marginRight: '30px', marginTop: '5px', marginBottom: '5px' }}
                          />
                        ) : (
                          <img
                            src={GotItBtnSrc}
                            id="imgGotIt"
                            alt="Got It"
                            onClick={() => { setShowPrcModal(false); setIsPrcLoading(false); }}
                            onMouseOver={handleGotItBtnMouseOver}
                            onMouseOut={handleGotItBtnMouseOut}
                            style={{ cursor: 'pointer', width: '100px', height: '40px', marginRight: '30px', marginTop: '5px', marginBottom: '5px' }}
                          />
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </>
          )}

          {showSolnModal && (
            <>
              <div id="divReadOnlyScreen" style={{ display: 'block' }} onClick={() => {
                setShowSolnModal(false);
              }}></div>

              <div id="divPCS" style={{ display: 'block', position: 'fixed', bottom: '0', width: '100%', zIndex: 10000 }}>
                <table id="tblTitlePCS" className="solution" cellSpacing="0" cellPadding="0" width="100%">
                  <tbody>
                    <tr>
                      <td id="tdPCSTitle1">Step by step solution</td>
                      <td id="tdPCSClose" align="right" valign="top">
                    <button
                      type="button"
                      aria-label="Close solution"
                      onClick={() => setShowSolnModal(false)}
                      style={{ width: '30px', height: '30px', margin: '5px 15px 5px 0', padding: 0, border: 0, borderRadius: 0, backgroundColor: '#ff6500', color: '#fff', fontSize: '18px', lineHeight: '30px', textAlign: 'center', cursor: 'pointer' }}
                    >
                      ×
                    </button>
                  </td>
                    </tr>
                  </tbody>
                </table>

                <div id="divFramePCS">
                  {isSolnLoading ? <Loading /> : (
                    <iframe
                      id="iFrameSolution"
                      ref={solnIframeRef}
                      title="Solution"
                      srcDoc={solnContent}
                      style={{ width: '100%', border: 'none', minHeight: '50px' }}
                      onLoad={() => {
                        const iframe = solnIframeRef.current;
                        if (!iframe || !iframe.contentDocument || !iframe.contentWindow) {
                          console.error("Iframe document or window not ready in onLoad.");
                          return;
                        }
                        try {
                          const iframeDoc = iframe.contentDocument;
                          const stepsInput = iframeDoc.getElementById('NoOfSteps') as HTMLInputElement;
                          const totalSteps = parseInt(stepsInput?.value || '0', 10);
                          setNoOfSteps(totalSteps);

                          const isAutoExpanded = iframeDoc.getElementById('IsAutoExpanded');

                          const stepRows = iframeDoc.querySelectorAll<HTMLElement>('[id^="trSolStepLHS"]');
                          stepRows.forEach((step) => {
                            step.querySelectorAll<HTMLElement>(':scope > td').forEach((cell) => {
                              if (!cell.style.color && !cell.hasAttribute('color')) cell.style.color = 'black';
                            });
                          });

                          stepRows.forEach((step, index) => {
                        const rhsCell = step.querySelector<HTMLElement>(':scope > td:last-of-type');
                        rhsCell?.style.setProperty('text-align', 'left', 'important');
                        rhsCell?.style.setProperty('padding-left', '12px', 'important');
                            if (index <= currentSolnNo || isAutoExpanded) {
                              step.style.display = 'table-row';
                            } else {
                              step.style.display = 'none';
                            }
                          });

                          if (totalSteps === 0) {
                            iframe.style.height = '50px';
                          }

                          setTimeout(() => {
                            if (!iframe.contentDocument || !iframe.contentDocument.body) return;

                            const totalRequiredHeight = iframe.contentDocument.body.scrollHeight + 5;

                            const divPCS = document.getElementById('divPCS') as HTMLElement;
                            const titleTable = document.getElementById('tblTitlePCS') as HTMLElement;
                            const navTable = document.getElementById('tblNavPCS') as HTMLElement;

                            if (!divPCS || !titleTable || !navTable) return;

                            const maxModalHeight = window.innerHeight * 0.45;
                            const chromeHeight = titleTable.offsetHeight + navTable.offsetHeight;
                            const maxAllowedIframeHeight = maxModalHeight - chromeHeight;

                            if (totalRequiredHeight > maxAllowedIframeHeight) {
                              iframe.style.height = `${maxAllowedIframeHeight}px`;
                              iframe.style.overflowY = 'auto';
                            } else {
                              iframe.style.height = `${totalRequiredHeight}px`;
                              iframe.style.overflowY = 'hidden';
                            }

                            iframe.contentWindow?.scrollTo(0, iframe.contentDocument.body.scrollHeight);

                          }, 50);

                          iframeDoc.querySelectorAll<HTMLImageElement>('img[id^="KsdImg"]').forEach(img => {
                        const index = img.id.substring(6);
                        const ksdDiv = iframeDoc.getElementById(`KsdDiv${index}`);
                        const content = ksdDiv?.getAttribute('data-ksd-content');
                        const wasPreviouslyRevealed = revealedSolnSteps.includes(Number(index));
                        const showCell = img.closest('td');
                        showCell?.style.setProperty('text-align', 'left', 'important');
                        showCell?.style.setProperty('padding-left', '12px', 'important');
                        const answerCell = ksdDiv?.closest('td') as HTMLTableCellElement | null;

                        const revealAnswer = () => {
                          if (!content || !showCell || !answerCell) return;
                          showCell.remove();
                          answerCell.colSpan = 2;
                          answerCell.innerHTML = content;
                          answerCell.style.setProperty('width', '50%', 'important');
                          answerCell.style.setProperty('max-width', 'none', 'important');
                          answerCell.style.setProperty('vertical-align', 'middle', 'important');
                          answerCell.style.setProperty('text-align', 'left', 'important');
                          answerCell.style.setProperty('padding-left', '12px', 'important');
                          answerCell.querySelectorAll<HTMLElement>('td').forEach(cell => {
                            cell.style.setProperty('text-align', 'left', 'important');
                            cell.style.setProperty('padding-left', '12px', 'important');
                          });
                        };

                        if (content && answerCell && wasPreviouslyRevealed) {
                          revealAnswer();
                          return;
                        }

                        img.onclick = () => {
                          if (img.getAttribute('alt') === '1') {
                            revealAnswer();
                            setRevealedSolnSteps(previous => previous.includes(Number(index)) ? previous : [...previous, Number(index)]);
                          }
                        };
                      });

                        } catch (e) {
                          console.error("Error inside solution iframe onLoad:", e);
                        }
                      }}
                    />
                  )}
                </div>

                <table id="tblNavPCS" className="solution" cellSpacing="0" cellPadding="0" width="100%" style={{ backgroundColor: '#F2F2F2' }}>
                  <tbody>
                    <tr>
                      <td align="left" style={{ width: '33%', paddingLeft: '15px' }}>
                      </td>

                      <td style={{ width: '34%' }}>
                        &nbsp;
                      </td>

                      <td align="right" style={{ width: '33%', paddingRight: '15px' }}>

                        {!isSolnLoading && noOfSteps > 0 && currentSolnNo < noOfSteps - 1 && (
                          <img
                            id="btnPCSNext"
                            src={NextStepBtnSrc}
                            alt="Next Step"
                            onClick={() => {
                              const nextStep = currentSolnNo + 1;
                              const iframe = solnIframeRef.current;

                              if (iframe?.contentDocument?.body) {
                                const iframeDoc = iframe.contentDocument;

                                const stepRows = iframeDoc.querySelectorAll<HTMLElement>('[id^="trSolStepLHS"]');
                                if (nextStep >= stepRows.length) return;

                                const nextStepElement = stepRows[nextStep];
                                nextStepElement.style.display = 'table-row';

                                setTimeout(() => {
                                  if (!iframe.contentDocument) return;

                                  const currentIframeHeight = iframe.offsetHeight;
                                  const newStepHeight = nextStepElement.scrollHeight;

                                  const divPCS = document.getElementById('divPCS') as HTMLElement;
                                  const titleTable = document.getElementById('tblTitlePCS') as HTMLElement;
                                  const navTable = document.getElementById('tblNavPCS') as HTMLElement;

                                  if (!divPCS || !titleTable || !navTable) return;

                                  const maxModalHeight = window.innerHeight * 0.45;
                                  const currentModalHeight = divPCS.offsetHeight;

                                  if (currentModalHeight >= maxModalHeight) {
                                    iframe.style.overflowY = 'auto';
                                  } else {
                                    const newIframeHeight = currentIframeHeight + newStepHeight;

                                    const maxIframeHeight = maxModalHeight - titleTable.offsetHeight - navTable.offsetHeight;

                                    if (newIframeHeight > maxIframeHeight) {
                                      iframe.style.height = `${maxIframeHeight}px`;
                                      iframe.style.overflowY = 'auto';
                                    } else {
                                      iframe.style.height = `${newIframeHeight}px`;
                                    }
                                  }

                                  iframe.contentWindow?.scrollTo(0, iframe.contentDocument.body.scrollHeight);

                                });

                                setCurrentSolnNo(nextStep);
                                if (solutionSeen !== 'Y') {
                                  setSolutionSeen(nextStep + 1);
                                }
                              }
                            }}
                            onMouseOver={handleNextStepBtnMouseOver}
                            onMouseOut={handleNextStepBtnMouseOut}
                            style={{ cursor: 'pointer' }}
                          />
                        )}

                        {!isSolnLoading && (noOfSteps === 0 || currentSolnNo === noOfSteps - 1) && (
                          <img
                            id="btnPCSClose"
                            src={GotItBtnSrc}
                            alt="Got It"
                            onClick={() => {
                              setShowSolnModal(false);
                              setSolutionSeen('Y');
                            }}
                            onMouseOver={handleGotItBtnMouseOver}
                            onMouseOut={handleGotItBtnMouseOut}
                            style={{ cursor: 'pointer', display: isSolnLoading ? 'none' : 'inline-block' }}
                          />
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </>
          )}

        </>,
        document.body
      )}

    </>
  );
};

export default forwardRef(DQns)
